import { defaultThemeV2 } from "../../theme/defaultThemeV2";
import type { QuestionCore } from "../contracts";

export type PhoneRaw = {
  type: "phone_number";
  content: string;
  default_country?: string;
  previous_response?: string;
  image?: string;
  alt_text?: string | null;
  error_message?: string;
};

export type PhoneDefinition = {
  prompt: string;
  country?: string;
  previousResponse: string;
  image?: string;
  altText?: string;
  error?: string;
};

export type PhoneDraft = { value: string };
export type PhoneEvent = { type: "set-value"; value: string };
export type PhoneResponse = {
  type: "text";
  value: string;
};

export const phoneCore: QuestionCore<
  PhoneRaw,
  PhoneDefinition,
  PhoneDraft,
  PhoneEvent,
  PhoneResponse
> = {
  decode: (raw) => {
    if (
      raw.previous_response !== undefined &&
      typeof raw.previous_response !== "string"
    ) {
      throw new Error("Phone previous response must be a string.");
    }
    return {
      prompt: raw.content,
      country: raw.default_country?.toLowerCase(),
      previousResponse: raw.previous_response ?? "",
      ...(raw.image ? { image: raw.image } : {}),
      ...(raw.alt_text ? { altText: raw.alt_text } : {}),
      ...(raw.error_message ? { error: raw.error_message } : {}),
    };
  },
  initialize: (definition) => ({ value: definition.previousResponse }),
  update: (_definition, _draft, event) => ({ value: event.value }),
  validate: (_definition, draft, copy = defaultThemeV2.copy) =>
    draft.value.length > 0
      ? { valid: true }
      : { valid: false, error: copy.validation.phone },
  encode: (definition, draft) => {
    const validation = phoneCore.validate(definition, draft);
    if (!validation.valid) throw new Error(validation.error);
    return { type: "text", value: `+${draft.value.replace(/^\++/, "")}` };
  },
  projectTranscript: (definition, draft) => ({
    kind: "phone_number",
    question: definition.prompt,
    answer: draft.value,
  }),
};
